import React from "react";
import "../styles/HomeCertificates.css";

function HomeCertificates() {
  return (
    <div className="home-certificates-container"> 
      <h2>Building Trust Through Official Recognition</h2>
      <img src="/certificates/ICL-CERTIFICATE.png" alt="Government Certification 1" />
      <img src="/certificates/msme.png" alt="Government Certification 2" />
      <img src="/certificates/FSSAI.png" alt="Government Certification 3" />
    </div>
  );
}

export default HomeCertificates;